"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeading = exports.ModalFooter = exports.ModalBody = exports.Modal = void 0;
var Modal_1 = require("./Modal");
Object.defineProperty(exports, "Modal", { enumerable: true, get: function () { return __importDefault(Modal_1).default; } });
var ModalBody_1 = require("./ModalBody");
Object.defineProperty(exports, "ModalBody", { enumerable: true, get: function () { return __importDefault(ModalBody_1).default; } });
var ModalFooter_1 = require("./ModalFooter");
Object.defineProperty(exports, "ModalFooter", { enumerable: true, get: function () { return __importDefault(ModalFooter_1).default; } });
var ModalHeading_1 = require("./ModalHeading");
Object.defineProperty(exports, "ModalHeading", { enumerable: true, get: function () { return __importDefault(ModalHeading_1).default; } });
